<template>
  <div class="h-auto ml-0 w-full lg:mr-3 min-h-screen">
    <div class="bg-white m-3 rounded-md">
      <div class="border-b-0.5 flex justify-between items-center p-3">
        <p class="text-sm font-semibold">List of requests</p>
      </div>
      <!-- search -->
      <input
        v-model="searchInput"
        type="search"
        placeholder="Start typing to search..."
        class="p-2 bg-gray-200 w-52 m-2 mb-0 pl-2 py-1 rounded-md"
      />
      <!-- search -->
      <div class="p-2 relative">
        <transition name="fade">
          <div v-if="loading" class="inset-0 absolute z-50 bg-white w-full">
            <loader class="center-h-v" />
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="showSuccess"
            class="p-1 text-center text-sm w-full bg-green-200"
          >
            {{ success_msg }}
          </div>
        </transition>
        <ve-table
          v-if="searchInput"
          :columns="columns"
          :table-data="filteredTableData"
        />
        <ve-table
          :columns="columns"
          :table-data="tableData"
          v-if="!searchInput.length"
        />
        <p
          v-if="tableData.length == 0 && !loading && !get_error"
          class="p-1 text-center text-sm w-full bg-gray-100"
        >
          No organizations to review
        </p>
        <transition name="fade">
          <div
            v-if="get_error"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ get_error }}
          </div>
        </transition>
      </div>
    </div>

    <review
      :showReviewOrganization="showReview"
      :organizationData="rowToReview"
      @close="close()"
      @handleSuccess="handleSuccess"
    ></review>
  </div>
</template>

<script>
import axios from "axios";
import Loader from "../components/loader/loader.vue";
import { mapGetters } from "vuex";
import { utils, writeFileXLSX } from "xlsx";
export default {
  name: "Requests",
  components: {
    Loader,
    Review: () => import("@/components/requests/review.vue"),
  },
  data() {
    return {
      loading: false,
      rowToReview: null,
      showReview: false,
      get_error: null,
      showSuccess: false,
      success_msg: null,
      searchInput: "",

      columns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 10,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },

        {
          field: "Name",
          key: "a",
          title: "Organization",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) => <p class="">{row.Name}</p>,
        },
        {
          field: "Email",
          key: "b",
          title: "Company Email",
          headerAlign: "left",
          align: "left",
        },
        {
          field: "Phonenumber",
          key: "c",
          title: "Phone",
          headerAlign: "left",
          align: "left",
        },
        {
          field: "TotalManagers",
          key: "x",
          title: "Managers",
        },
        {
          field: "TotalNormalEmployees",
          key: "xy",
          title: "Employees",
        },
        {
          field: "SubscriptionStatus",
          key: "xs",
          title: "Status",
          renderBodyCell: ({ row }) => {
            return row.SubscriptionStatus.toLowerCase() === "trial" ? (
              <p class="text-white bg-red-500 p-1 py-1  rounded-md  w-20 mx-auto">
                {row.SubscriptionStatus}
              </p>
            ) : (
              <p class="text-white bg-green-500 p-1 py-1  rounded-md  w-20 mx-auto">
                {row.SubscriptionStatus}
              </p>
            );
          },
        },
        {
          field: "Disabled",
          key: "xss",
          title: "Disabled",
          renderBodyCell: ({ row }) => {
            return row.Disabled ? (
              <p class="text-white bg-red-500 p-1 py-1  rounded-md  w-20 mx-auto">
                True
              </p>
            ) : (
              <p class="text-white bg-green-500 p-1 py-1  rounded-md  w-20 mx-auto">
                False
              </p>
            );
          },
        },
        {
          field: "Review",
          key: "f",
          title: "Action",
          renderBodyCell: ({ row }) => {
            return (
              <div>
                <button
                  on-click={() => this.openReview(row)}
                  class="bg-primary text-white p-1 py-1  rounded-md  font-medium text-sm w-20 mx-auto"
                >
                  View
                </button>
              </div>
            );
          },
        },
      ],
      tableData: [],
    };
  },
  computed: {
    ...mapGetters(["getToken"]),
    filteredTableData() {
      if (!this.searchInput) {
        // If no search input is provided, return the full tableData
        return this.tableData;
      } else {
        // Filter the tableData based on the search input
        const searchInputLower = this.searchInput.toLowerCase();
        return this.tableData.filter((item) => {
          // Loop through each item's properties and check if they contain the search input
          for (let key in item) {
            if (
              item[key]?.toString().toLowerCase().includes(searchInputLower)
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },
  },
  created() {
    this.getRequests();
  },
  methods: {
    close() {
      this.rowToReview = null;
      this.showReview = false;
    },
    handleSuccess(message) {
      this.rowToReview = null;
      this.showReview = false;
      this.success_msg = message;
      this.showSuccess = true;
      setTimeout(() => {
        this.showSuccess = false;
      }, 3000);
      this.getRequests();
    },
    openReview(row) {
      //console.log(row)
      this.rowToReview = row;
      this.showReview = true;
    },
    getRequests() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(`organization/${this.$ApiVersion}/request`, options).then(
        (response) => {
          this.loading = false;
          if (response.data.StatusCode == 200) {
            this.tableData = response.data.Data.filter(
              (item) => !item.Approved
            );
          } else {
            this.get_error = response.data.StatusMessage;
          }
        },
        (error) => {
          this.loading = false;
          this.get_error = error.message;
        }
      );
    },

    exportTemplate() {
      const ws = utils.json_to_sheet(this.tableData);
      const wb = utils.book_new();
      utils.book_append_sheet(wb, ws, "Data");

      writeFileXLSX(wb, "requests.xlsx");
    },
  },
};
</script>
